app.service('deliveryPoints', function (orderConfig, modal, tooltip,
	deliveryPointModal, deliveryPointLocation, deliveryPointAutocomplete,
	saveDeliveryData, geolocation, console, html, broker, scroll) {
	var config, url, autocompleteInput, savedParams = {};
	var $self, $list, $parcelType, $shopAvailability, $form, $points, $more, $lastPointBox;
	let selectedTypes = [];
	let isLoading = false;
	let firstLoad = true;
	let selectedAutocompletePlace = {};
	let version;
	let deliveryType;

	broker.on('BEFORE_PAGE_CHANGE', function () {
		selectedAutocompletePlace = {};
		isLoading = false;
		savedParams = {};
		selectedTypes = [];
		firstLoad = true;
	});

	let isScriptLoading = false;
	function loadScript() {
		if (!isScriptLoading) {
			isScriptLoading = true;
			var head = document.getElementsByTagName('head')[0];

			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = "false";
			script.src = "https://maps.googleapis.com/maps/api/js?v=3&key=" + orderConfig.getData().mapsApiKey + "&language=pl&libraries=places";
			head.appendChild(script);

			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = "false";
			script.src = "https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js";
			head.appendChild(script);
		}
	}

	function setElements() {
		$self = $('#delivery-points');
		$form = $('#choose-delivery-form');
		$list = $('#delivery-points-list', $self);
		$parcelType = $('.js-parcel-type', $self);			// dla parceli
		$shopAvailability = $('.js-shop-filter', $self);		// dla sklepów
		$lastPointBox = $('#last-saved-point', $self);
		autocompleteInput = $('.place-search', $self)[0];
		loadScript();
	}
	function setEvents() {
		$self.on('click', '.js-delivery-point', function () {
			var $this = $(this);
			if ($this.data('available') == false) {
				return;
			}
			$points.removeClass('selected');
			$this.addClass('selected');
			selectPoint($this.closest('.delivery-point')[0].outerHTML);
		}).on('click', '.js-toggle-openings-hours', function (event) {
			$(this).closest('.js-delivery-point').toggleClass('show-opening-hours');
			event.preventDefault();
			event.stopPropagation();
		}).on('click', '.js-more-delivery-points', function () {
			filter({ count: savedParams.count + 10 });
		}).on('click', '.js-parcel-type', function () {
			setSelectedParcelType($(this).data('type'));
			filter({ types: selectedTypes });
		}).on('click', '.js-shop-filter', function () {
			setSelectedAvailableType($(this).data('filter'));
		}).on('click', '.js-show-map', function () {
			selectedAutocompletePlace.input = autocompleteInput.value;
			deliveryPointModal.open(selectedAutocompletePlace, function (params) {
				$lastPointBox.html(params.html);
				selectPoint(params.html);
			});
		}).on('click', '.js-delivery-points-search', function () {
			var $this = $(this);
			$self.addClass('loading search-geolocation');
			geolocation.findPosition(function (position) {
				$self.removeClass('loading search-geolocation');
				$this.attr({
					latitude: position.latitude,
					longitude: position.longitude
				});
				load({
					latitude: position.latitude,
					longitude: position.longitude
				});
			}, function () {
				$self.removeClass('loading search-geolocation');
			});
		}).on('click', '.js-search-button', function () {
			const autocompleteInputValue = $(autocompleteInput).val();
			if (autocompleteInputValue != '') {
				deliveryPointLocation.findPlaceByAddress(autocompleteInputValue, function (location, partialMatch) {
					if (location && !partialMatch) {
						setSelectedAutocompletePoint(location);
					} else {
						showEmptyResults();
					}
				});
			}
		});
		$('.js-show-new-map').on('click', function () {		// TODO to zdarzenie jest poza selfem, do zastanowienia co dalej
			modal.showInternal();
			selectedAutocompletePlace.input = autocompleteInput.value;
			deliveryPointModal.open(selectedAutocompletePlace, function (params) {
				selectPoint(params.html);
			});
		});
		setAutocomplete();
	}
	function setSelectedAvailableType(type) {
		$shopAvailability.removeClass('selected');
		$shopAvailability.filter('[data-filter="' + type + '"]').addClass('selected');
		filter({ available: type });
	}
	function setSelectedParcelType(type) {
		const $selectAll = $('.js-parcel-type[data-type=0]', $self);
		const idx = $.inArray(type, selectedTypes);
		if (type == '0') {
			selectedTypes = [];
		} else {
			if (idx == -1) {
				selectedTypes.push(type);
			} else {
				selectedTypes.splice(idx, 1);
			}
		}
		$parcelType.removeClass('selected');
		if (!selectedTypes.length) {
			$selectAll.addClass('selected');
		} else {
			$selectAll.removeClass('selected');
			selectedTypes.forEach(function (t) {
				$parcelType.filter('[data-type="' + t + '"]').addClass('selected');
			});
		}
	}

	function showEmptyResults() {
		$self.addClass('empty-location');
		$('.empty-location-message strong', $self).text(autocompleteInput.value.trim());
	}

	function setAutocomplete() {
		deliveryPointAutocomplete.setAutocomplete(autocompleteInput, function (location) {
			if (location) {
				setSelectedAutocompletePoint(location);
			}
		}, function () {
			showEmptyResults();
		});
	}

	function setSelectedAutocompletePoint(location) {
		load({
			latitude: location.lat(),
			longitude: location.lng()
		});
	}


	function selectPoint(selectedHtml) {
		$lastPointBox.html(selectedHtml);
		var $lastPoint = $lastPointBox.find('.js-delivery-point');
		if (!$lastPoint.length) {
			modal.alert('Niepoprawne dane punktu odbioru');
			return;
		}
		var data = {
			point: $lastPoint.data('point'),
			city: $lastPoint.data('city'),
			type: $lastPoint.data('type'),
			courier: $lastPoint.data('courier'),
			taxfree: $lastPoint.data('taxfree')
		}
		$points.removeClass('selected').filter('[data-point="' + data.point + '"]').addClass('selected');
		$lastPoint.addClass('selected');
		console.log('wybrany punkt', data);
		$('#parcel-point-code-error, #inpost-point-error').remove();
		$('#inpost-point, #parcel-point-code').remove();
		$list.removeClass('validate-error');
		if (version == 'old') {
			scroll.to({ $element: $self });
		} else {
			modal.close('delivery-points-modal');
		}
		if (version == 'old') {
			$self.addClass('saving loading');
		}
		var types = {
			INPOST: 'INPOST',
			SHOP: 'SHOP',
			POST_OFFICE_POINT: 'POCZTA_POLSKA_OFFICE',
			ORLEN_PARCEL_POINT: 'ORLEN_PARCEL',
			DHL_PARCEL_POINT: 'DHL_PARCEL',
			DPD_PARCEL_POINT: 'DPD_PARCEL'
		}
		saveDeliveryData.send({
			pickupPointType: types[data.courier],
			pickupPointCode: data.point,
			cityCode: data.city
		}, function (isSaving) {
			if (isSaving) {
				if (version == 'old') {
					$self.removeClass('saving loading');
					var t = $('#preview-order-steps .row-delivery-point').detach();
					$('#short-delivery-address-data').empty().append(t);
					$('#container').removeClass('edit-points');
				}
				if (data.courier == 'SHOP') {
					config.shopCode = '' + data.point;
					config.taxfreeAvailable = data.taxfree;
					config.cityCode = '' + data.city;
				} else {
					config.parcelCode = '' + data.point;
					config.cityCode = '' + data.city;
				}
			} else {
				if (version == 'old') {
					$('#container').removeClass('edit-points');
					$self.removeClass('saving loading');
				}
			}
			// filter({ types: selectedTypes, count: 3 });
		}, function () {
			if (version == 'old') {
				$self.removeClass('saving loading');
			}
			if (deliveryType == 'inpost') {
				modal.alert('Błąd zapisania wybranego paczkomatu. Spróbuj ponownie.');
			} else if (deliveryType == 'pickupPoint') {
				modal.alert('Błąd zapisania wybranego punktu odbioru. Spróbuj ponownie.');
			} else {
				modal.alert('Błąd zapisania wybranego sklepu. Spróbuj ponownie.');
			}
		});
	}

	function init() {
		config = orderConfig.getData();
		version = html.has('points-on-modal') ? 'new' : 'old';
		if (version == 'new') {
			if (config.pageType == 'basket') {
				$('#delivery-step-points-modal > #delivery-points, #delivery-step-points-modal > #modal-delivery-points').remove();	// kasujemy bloczek z k2
			} else {
				$('.delivery-form-fields > #delivery-points, .delivery-form-fields > #modal-delivery-points').remove();			// kasujemy tutaj bloczki z wersji A, czyli dotychczasowe bloczki
			}
			modalContent = $('#new-delivery-points').html();
			$('#new-delivery-points').remove();
			modal.generate({
				id: 'delivery-points-modal',
				modifier: 'remodal-right',
				content: modalContent,
				show: false
			});
		} else {
			$('#new-delivery-points').remove();
		}
		setElements();
		setEvents();
		deliveryType = config.pageType == 'basket' ? config.deliveryTypeName : config.deliveryType;
		if (config.pageType == 'basket') {
			if (deliveryType == 'inpost') {		// koszyk używa już deliveryType jako liczby
				url = '/parcelMachines-list.ltr';
			} else if (deliveryType == 'pickupPoint') {
				url = '/cart-pickup-points.ltr';
			} else if (deliveryType == 'shop') {
				url = '/cart-shops.ltr';
			}
		} else {
			if (deliveryType == 'inpost') {
				url = '/parcelMachines-list.ltr';
			} else if (deliveryType == 'pickupPoint') {
				url = '/order-pickup-points.ltr';
			} else if (deliveryType == 'shop') {
				url = '/order-shops.ltr';
			}
		}
	}
	function filter(params) {									// nie była weryfikowana
		savedParams = $.extend(savedParams, params);
		console.log('filtrowanie', savedParams);
		$points.removeClass('visible');
		var $filtered = $points;
		if (savedParams.types && savedParams.types.length > 0) {						// wyfiltrowanie tylko punktów z konkretnego typu
			$filtered = $points.filter(function () {
				return savedParams.types.includes($(this).data('type'));
			});
		}
		if (savedParams.available == 'all') {
			$filtered = $points.filter('[data-available="true"], [data-available="false"]');
		}
		if (savedParams.available == 'available') {
			$filtered = $points.filter('[data-available="true"]');
		}
		$self.removeClass('empty-search empty-filter');
		if ($filtered.length == 0) {
			if (savedParams.types && savedParams.types.length != 0) {
				$self.addClass('empty-filter');
			} else {
				$self.addClass('empty-search');
			}
		}
		if ($filtered.length > savedParams.count) {
			$self.addClass('show-more');
		} else {
			$self.removeClass('show-more');
		}
		var $visible = $filtered.slice(0, savedParams.count);
		$($visible).addClass('visible');
	}
	function showFilters() {
		if (deliveryType == 'pickupPoint') {
			$self.addClass('show-filters');
		} else if (deliveryType == 'shop') {
			const all = $points.length;
			const available = $points.filter('[data-available="true"]').length;
			const notAvailable = $points.filter('[data-available="false"]').length;
			if (available > 0 && notAvailable > 0) {
				$self.addClass('show-filters');
				savedParams.available = 'available';
			}
		}
	}

	function load(ajaxParams = {}, params = {}) {
		$self.addClass('loading');
		$self.removeClass('empty-location');
		isLoading = true;
		$('#inpost-point-error, #parcel-point-code-error').remove();
		if (ajaxParams.latitude && ajaxParams.longitude) {
			selectedAutocompletePlace.lat = ajaxParams.latitude;
			selectedAutocompletePlace.lng = ajaxParams.longitude;
		}
		if (params && params.point) {
			savedParams.selectedPoint = params.point;
		}
		if (config.pageType !== 'basket' && config.deliveryInfo.taxfree) {
			ajaxParams.taxFree = true;
		}
		$.ajax({
			url: url,
			data: ajaxParams,
			success: function (htmlResponse) {
				if (deliveryType !== 'shop') {	// sklepy mają tylko nową wersję. Paczkomaty i punkty mają w odpowiedzi generowane dwie wersje, przy sprzątanie będzie to do usunięcia
					$list.html($('<div>' + htmlResponse + '</div>').find(version == 'new' ? '.new-version' : '.old-version').html());
				} else {
					$list.html(htmlResponse);
				}

				$self.addClass('show-list');
				$points = $('.js-delivery-point', $list);
				$more = $('.js-more-delivery-points', $list);
				showFilters();
				setVisibleTypes();
				filter({ types: selectedTypes, count: version == 'new' ? 4 : 3 });
				tooltip.setEventOnElement($list);
				isLoading = false;
				if (version == 'old') {
					if ($('.delivery-badge').length) {
						let $b = $('.delivery-badge').detach();
						$b.appendTo("#delivery-banner");
					} else {
						$('#delivery-banner').remove();
					}
				}
				if (firstLoad) {
					firstLoad = false;
					if (version == 'old') {
						scroll.to({ $element: $self });
					}
				}
				if (version == 'new' && params && savedParams.selectedPoint) {
					$points.filter('[data-point="' + savedParams.selectedPoint + '"]').addClass('selected');
				}
			},
			complete: function () {
				$self.removeClass('loading');
				isLoading = false;
			},
			error: function () {
				const messageText = deliveryType == 'shop' ? 'Błąd ładowania sklepów. Spróbuj ponownie' : (deliveryType == 'pickupPoint' ? 'Błąd ładowania punktów odbioru. Spróbuj ponownie' : 'Błąd ładowania listy paczkomatów. Spróbuj ponownie');
				modal.alert(messageText);
			}
		});
	}
	function setVisibleTypes() {
		if (deliveryType == 'pickupPoint') {
			$parcelType.not('[data-type="0"]').addClass('hidden');
			$points.each(function () {
				var type = $(this).data('type');
				$parcelType.filter('[data-type="' + type + '"]').removeClass('hidden');
			});
			$parcelType.filter('.selected.hidden').each(function () {
				setSelectedParcelType('0');
			});
		} else if (deliveryType == 'shop') {
			$shopAvailability.removeClass('selected').filter('[data-filter="' + savedParams.available + '"]').addClass('selected');
		}
	}
	function show(data) {
		if (version == 'new') {
			modal.open('delivery-points-modal');
		} else {
			$('#container').addClass('edit-points');
			scroll.to({ $element: $('#delivery-points') });
		}
		if (data && data.taxfreeChanged) {
			if (firstLoad) {
				load({
					shopCode: config.shopCode,
				}, {
					point: config.shopCode
				});
			}
		} else if ($self && firstLoad && data && data.latitude && data.longitude) {
			load({
				longitude: data.longitude,
				latitude: data.latitude
			}, {
				point: data.selectedPoint || false
			});
		} else if ($self && data && data.selectedPoint !== savedParams.selectedPoint && data.latitude && data.longitude) {
			load({
				longitude: data.longitude,
				latitude: data.latitude
			}, {
				point: data.selectedPoint || false
			});
		}
	}
	function reloadShops() {
		if (deliveryType == 'shop') {
			if (selectedAutocompletePlace && selectedAutocompletePlace.lat) {
				load({
					longitude: selectedAutocompletePlace.lng,
					latitude: selectedAutocompletePlace.lat
				});
			} else if (config.shopCode.length) {
				load({
					shopCode: config.shopCode
				});
			}
		}
	}
	function checkTaxFree() {
		if (!firstLoad) {
			reloadShops();
		}
		//warunki kiedy pokazujemy modal, i tak zawsze go pokazujemy
		if (config.deliveryInfo.taxfree && config.shopCode.length && !config.taxfreeAvailable) {	// włączony jest taxfree a zapisany sklep nie ma taxfree
			modal.alert('Wybierz sklep, w którym chcesz odebrać zamówienie. W obecnie wybranym sklepie nie ma możliwości realizacji Tax Free.', function(){
				show({ taxfreeChanged: true });
			});
		}

	}

	return {
		init, show, checkTaxFree
	};
});
